const VueIdomooPlayer = {
  install (Vue, options) {
    /* eslint-disable */
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = options.environment + 'assets/js/eng.js';
      js.async = false;
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'idomooEngine'));

    window.IdmEngineCallback = function () {
      Vue.prototype.$idomooPlayer = {}
      Vue.prototype.$idomooPlayer.init = (options) => {
        Idm.Engine.init(options)
      };

      document.dispatchEvent(
        new CustomEvent('idomooPlayerReady', {})
      )
    };
    /* eslint-enable */
  }
}

export default VueIdomooPlayer



// WEBPACK FOOTER //
// ./WebResources/vue/shared/plugins/VueIdomooPlayer.js